import { useState, useCallback } from 'react';
import { ConfirmOptions, DialogState } from './types';

/**
 * 確認ダイアログのロジックを管理するカスタムフック
 */
export const useConfirmDialogProvider = () => {
  // ダイアログの状態
  const [dialogState, setDialogState] = useState<DialogState>({
    isOpen: false,
    title: '確認',
    message: '',
    confirmLabel: '続行する',
    cancelLabel: 'キャンセル',
    resolvePromise: null
  });

  /**
   * 確認ダイアログを表示する関数
   * @returns {Promise<boolean>} 確認ボタンが押されたらtrueを返すPromise
   */
  const confirm = useCallback((options: ConfirmOptions = {}): Promise<boolean> => {
    return new Promise((resolve) => {
      setDialogState({
        isOpen: true,
        title: options.title || '確認',
        message: options.message || '続行しますか？',
        confirmLabel: options.confirmLabel || '続行する',
        cancelLabel: options.cancelLabel || 'キャンセル',
        resolvePromise: resolve
      });
    });
  }, []);

  /**
   * 確認ボタンが押された時の処理
   */
  const handleConfirm = useCallback(() => {
    if (dialogState.resolvePromise) {
      dialogState.resolvePromise(true);
    }
    setDialogState(prev => ({ ...prev, isOpen: false }));
  }, [dialogState]);

  /**
   * キャンセルボタンが押された時の処理
   */
  const handleCancel = useCallback(() => {
    if (dialogState.resolvePromise) {
      dialogState.resolvePromise(false);
    }
    setDialogState(prev => ({ ...prev, isOpen: false }));
  }, [dialogState]);

  return {
    dialogState,
    confirm,
    handleConfirm,
    handleCancel
  };
}; 